// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11hQ5","colBig":"styles_colBig__2cqt5","colSmall":"styles_colSmall__VV6js"};